/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import ImageUpload from 'material/imageupload/imageupload_container';
import Image from 'material/embeds/imageapi/imagepane/image/image_container';
import Loading from 'material/embeds/imageapi/imagepane/loading/loading';
//utils
import { userImagesCancel } from 'utils/api/embed';
import { USERIMAGES } from 'state/actions/embedsState/embedManagementState/image_status';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/imageapi/imagepane/pane/yourown/yourown_styles';



/* ========== ~~~~~~~~~~ IMAGE PANE : YOUR OWN ~~~~~~~~~~ ========== */
class YourOwn extends Component {
	constructor(props) {
		super(props);
		this.uploadImage = this.uploadImage.bind(this);
		this.previewEmbedImage = this.previewEmbedImage.bind(this);
		this.fetchUserImages = this.fetchUserImages.bind(this);
	};

	componentDidMount() {
		this.props.resetQuery('');
		this.fetchUserImages();
	};

	componentWillUnmount(){
		if (this.props.isDataReceived){
			userImagesCancel();
		}
	}

	fetchUserImages() {
		let UUID = this.props.accountUUID;
		this.props.getUserImages(UUID);
	};

	uploadImage(imageFile) {
		const selectedOptionId = this.props.activeSelection.includes('option') ? this.props.activeSelection.slice(7) : null;
		this.props.setSelectedImage(null, null, URL.createObjectURL(imageFile));
		this.props.uploadCustomImage(this.props.selectedContent, selectedOptionId, this.props.accountUUID, imageFile);
	};

	previewEmbedImage(imageFile) {
		this.props.setPreviewImage(imageFile);
	};

	renderImages() {
			return this.props.images.data.map((image, i) => {
				return (
					<span className={`imagecontainer`} key={i} >
						<Image key={`user-image-${i}`} provider={'CLIENT_UPLOADED'} id={null}
							previewUrl={image}
							url={image} />
					</span>
				)
			});
	};

	render() {
		return (
			<div className={`pane yourown ${this.props.classes.yourown}`}>
        {/* make imageSize from 150px to 180px to make the cropper image more visible to the user */}
                <div className={'innerPane'} ><ImageUpload processImage={this.uploadImage} previewImage={this.previewEmbedImage} uploadingCustomImage={this.props.uploadingCustomImage} imageSize={{ width: '180px', height: 'auto' }} cropSize={{ width: 146, height: 178 }} />
				{(this.props.provider === USERIMAGES && this.props.isDataReceived && this.props.images.length > 0 && !this.props.error) ?
					this.renderImages() : <Loading yourown={true} error = {this.props.error} images={(this.props.isDataReceived && this.props.images.length === 0)} />}
				</div>
			</div>
		)
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(YourOwn);
